import { render } from "./MultipleChoiceQuestions.vue?vue&type=template&id=f18b7196"
import script from "./MultipleChoiceQuestions.vue?vue&type=script&lang=js"
export * from "./MultipleChoiceQuestions.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__